module.exports = __webpack_public_path__ + "fonts/Muli-Black.66c9d5ed.woff";